import React from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcherDev = () => {
    const { i18n } = useTranslation();

    // Solo mostrar en desarrollo
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 9999,
            backgroundColor: 'white',
            padding: '10px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            border: '2px solid #007bff'
        }}>
            <div style={{ marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                DEV: Cambiar idioma
            </div>
            <button 
                onClick={() => i18n.changeLanguage('es')}
                style={{
                    margin: '2px',
                    padding: '8px 12px',
                    backgroundColor: i18n.language === 'es' ? '#007bff' : '#fff',
                    color: i18n.language === 'es' ? '#fff' : '#000',
                    border: '1px solid #007bff',
                    borderRadius: '4px',
                    cursor: 'pointer'
                }}
            >
                🇪🇸 ES
            </button>
            <button 
                onClick={() => i18n.changeLanguage('en')}
                style={{
                    margin: '2px',
                    padding: '8px 12px',
                    backgroundColor: i18n.language === 'en' ? '#007bff' : '#fff',
                    color: i18n.language === 'en' ? '#fff' : '#000',
                    border: '1px solid #007bff',
                    borderRadius: '4px',
                    cursor: 'pointer'
                }}
            >
                🇺🇸 EN
            </button>
            <button 
                onClick={() => i18n.changeLanguage('pt')}
                style={{
                    margin: '2px',
                    padding: '8px 12px',
                    backgroundColor: i18n.language === 'pt' ? '#007bff' : '#fff',
                    color: i18n.language === 'pt' ? '#fff' : '#000',
                    border: '1px solid #007bff',
                    borderRadius: '4px',
                    cursor: 'pointer'
                }}
            >
                🇧🇷 PT
            </button>
            <div style={{ marginTop: '5px', fontSize: '10px', color: '#666' }}>
                Actual: {i18n.language.toUpperCase()}
            </div>
        </div>
    );
};
